export default {
  meta: {
    title: "PixelHaha {'|'} Imagens de Stock Grátis para Download",
    description:
      "Explore uma grande variedade de imagens impressionantes. De paisagens a arte abstrata, todas as imagens são gratuitas e perfeitas para enriquecer suas ideias de design e gráficos de mídia social.",
    keywords: "grátis, estoque, galeria, texto para imagem, geração de IA",
    searchTitle:
      "PixelHaha {'|'} {number}+ Melhor {keyword} · Download 100% gratuito",
    searchDescription:
      "Descarregue as fotos {keyword} perfeitas. Encontre mais de {number}+ das melhores imagens {keyword} gratuitas. Gratuito para uso comercial Não é necessária qualquer atribuição.",
    404: "Erro 404 - PixelHaha",
  },
};
